import * as angular from 'angular';
import bugsnagJs from 'bugsnag-js';

angular
  .module('exceptionOverride', [])
  .factory('$exceptionHandler', ['$log', 'bugsnagClient', ($log, bugsnagClient) => {
    return function (exception, cause) {
      $log.error(exception);

      bugsnagClient.notify(exception, {
        beforeSend(report) {
          report.updateMetaData('angular', { cause });

          const fullstory: any = (<any>window).FS;

          // Make sure FullStory object exists.
          if (fullstory && fullstory.getCurrentSessionURL) {
            report.updateMetaData('fullstory', {
              urlAtTime: fullstory.getCurrentSessionURL(true),
            });
          }
        },
      });
    };
  }]);



// WEBPACK FOOTER //
// ./resources/assets/js/legacy/bugsnag.ts